export default {"src":"/_next/static/media/icon-profile.73ef0611.svg","height":16,"width":16};